/**
 * Calculate the distance between two coordinates using the Haversine formula
 * @param {Object} coord1 - First coordinate {lat: number, lng: number}
 * @param {Object} coord2 - Second coordinate {lat: number, lng: number}
 * @returns {number} Distance in meters
 */
export function haversineDistance(coord1, coord2) {
  const R = 6371000; // Earth's radius in meters
  const toRad = angle => (angle * Math.PI) / 180;

  const lat1 = toRad(coord1.lat);
  const lat2 = toRad(coord2.lat);
  const deltaLat = toRad(coord2.lat - coord1.lat);
  const deltaLng = toRad(coord2.lng - coord1.lng);

  const a =
    Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
}

/**
 * Convert meters to miles
 * @param {number} meters
 * @returns {number} Distance in miles
 */
export function metersToMiles(meters) {
  return meters / 1609.344;
}

/**
 * Convert miles to meters
 * @param {number} miles
 * @returns {number} Distance in meters
 */
export function milesToMeters(miles) {
  return miles * 1609.344;
}
